import React from 'react';
import { useTheme } from 'styled-components';
import { RemoveIc, CheckmarkIc } from '@dsch/dd-icons';
import * as Styled from '../../../../../components/PageWrappers/AdDetails/components/VerifiedList/VerifiedList.styled';
import {
  VerificationsKeys,
  VerifiedListProps,
} from '../../../../../components/PageWrappers/AdDetails/components/VerifiedList/VerifiedList.typed';

function VerifiedList({
  layout = 'SINGLE_LINE',
  verification = {},
  className,
}: VerifiedListProps) {
  const theme = useTheme();
  const { email, phone, bank } = verification;
  const validVerifications = { email, phone, bank };

  const verificationTextMap = {
    email: 'Email',
    phone: 'Phone',
    bank: 'Payment card',
  };

  return (
    layout && (
      <Styled.VerifiedContainer layout={layout} className={className}>
        {layout === 'SINGLE_LINE' && (
          <Styled.P layout={layout}>Verified:</Styled.P>
        )}
        {verification &&
          (Object.keys(validVerifications) as Array<VerificationsKeys>).map(
            (verify) =>
              verification[verify] ? (
                <Styled.P
                  key={verify}
                  layout={layout}
                  data-testid={`verified-text-${verify}`}
                >
                  <CheckmarkIc
                    color={theme.colors.GREEN}
                    width="16"
                    height="16"
                  />
                  {verificationTextMap[verify]}
                  {layout === 'TWO_COLUMN' && ' verified'}
                </Styled.P>
              ) : (
                <Styled.SP
                  key={verify}
                  layout={layout}
                  data-testid={`not-verified-text-${verify}`}
                >
                  <RemoveIc color={theme.colors.GREY} width="16" height="16" />
                  {verificationTextMap[verify]}
                </Styled.SP>
              ),
          )}
      </Styled.VerifiedContainer>
    )
  );
}

export { VerifiedList };
